export default __webpack_public_path__ + "static/media/modelx.6b2c17b2.jpg";